import React, { Fragment } from "react";
import Button from "@mui/material/Button";
import { Typography, CircularProgress } from "@mui/material";
import classNames from "classnames";
import styles from "../styles";
import compose from "recompose/compose";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { ApproveMailingListPendingActions } from "./ApproveMailingListPendingActions";
import { propertyUtil } from "views/Pma/PropertyUtil";
// TEMPORARY imports - remove after 1 month
// import SummerEventsConfirmationDialog from "./SummerEventsConfirmationDialog";
// import { SummerEventsUtils } from "./SummerEventsUtils";
import { MailProDialog } from "../MailProDialog/MailProDialog";
import { MailProDialogHeader } from "../MailProDialog/MailProDialogHeader";
import { MailProDialogBody } from "../MailProDialog/MailProDialogBody";

const ApprovalMailingListDialog = (props) => {
  const {
    classes,
    approveMailingListFn = () => {},
    continueEditingModeFn = () => {},
    mlsAreas = [],
    areaName = null,
    hoFilter,
    currentArea = null,
  } = props;
  const [open, setOpen] = React.useState(true);
  const [isLoading, setLoading] = React.useState(false);
  //   const [showSummerEventsDialog, setShowSummerEventsDialog] =
  //     React.useState(false);

  const { showBox, areaCount } = propertyUtil.getUnapprovedAreaCount(mlsAreas);

  // Get area ID from currentArea
  const areaID =
    currentArea && currentArea.mlsAreaID ? currentArea.mlsAreaID : null;

  // Check if summer events confirmation is needed
  //   React.useEffect(() => {
  //     setShowSummerEventsDialog(false); //remove for September- Amit I'm removing this for now so it doesnt show for prop highlights July
  //     setOpen(false); // Hide the main dialog initially
  //     // if (areaID && !SummerEventsUtils.hasConfirmedSummerEvents(areaID)) {
  //     //   // setShowSummerEventsDialog(true);
  //     //   setShowSummerEventsDialog(false);  //remove for September- Amit I'm removing this for now so it doesnt show for prop highlights July
  //     //   setOpen(false); // Hide the main dialog initially
  //     // }
  //   }, [areaID]);

  const handleClose = () => {
    setOpen(false);
  };

  //   const handleSummerEventsConfirm = () => {
  //     setShowSummerEventsDialog(false);
  //     setOpen(false);
  //     // setOpen(true); // remove for September and show regular setopen to trueShow the main approval dialog
  //   };

  //   const handleSummerEventsClose = () => {
  //     setShowSummerEventsDialog(false);
  //     // If they close without confirming, also close the main flow
  //     handleClose();
  //   };

  return (
    <div>
      {/* Summer Events Confirmation Dialog */}
      {/*{showSummerEventsDialog && areaID && (
        <SummerEventsConfirmationDialog
          areaName={areaName}
          areaID={areaID}
          onConfirm={handleSummerEventsConfirm}
          onClose={handleSummerEventsClose}
        />
      )}
*/}
      {/* Main Approval Dialog */}
      <MailProDialog
        open={open}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="approval-mailing-list-dialog"
        aria-describedby="approval-mailing-list-dialog"
        maxWidth="lg"
        fullWidth={true}
        disableEscapeKeyDown={true}
        classes={{
          paper: classes.approvalDialogPaper,
        }}
      >
        <MailProDialogHeader>
          <Typography
            variant="subtitle1"
            align="center"
            className={`${classes.whiteColor} ${classes.boldFont}`}
          >
            Ahhhh… Looks like you've finished all your edits for area {areaName}
            . Great!
          </Typography>
        </MailProDialogHeader>

        <MailProDialogBody>
          <ApproveMailingListPendingActions
            {...props}
            mode="body"
            handleClose={handleClose}
          >
            <Fragment>
              {/* <Typography
                variant="subtitle2"
                align="center"
                className={classNames(classes.primaryColor, classes.boldFont)}
              >
                Ahhhh… Looks like you’ve finished all your edits for area{" "}
                {areaName}. Great!
              </Typography> */}
              <br />
              <Typography variant="subtitle2" align="center">
                Just checking…
              </Typography>
              <br />
              <Typography variant="body1" align="center">
                Before you finish up, we just want to make sure you’re 100%
                satisfied with your work.
              </Typography>
              <Typography variant="body1" align="center">
                If you’re sure you’re all done making any changes to your PMA
                and to MailPro, then just click the{" "}
                <span
                  className={classNames(classes.greenColor, classes.boldFont)}
                >
                  OK, I’M FINISHED
                </span>{" "}
                button.
              </Typography>
              <br />
              <Typography
                variant="body1"
                align="center"
                className={classes.boldFont}
              >
                (You won’t be able to make any more changes after this)
              </Typography>
              <br />
              <Typography variant="body1" align="center">
                OR
              </Typography>
              <br />
              <Typography variant="body1" align="center">
                If you’d like to continue editing your PMA or MailPro, just
                click{" "}
                <spna
                  className={classNames(classes.primaryColor, classes.boldFont)}
                >
                  CONTINUE EDITING
                </spna>
                .
              </Typography>
              <br />
              {showBox && areaCount > 0 ? (
                <div className={classNames(classes.unapproveAreaDivDialog)}>
                  <Typography variant="body1" className={classes.whiteColor}>
                    Please Note: You have {areaCount} remaining area
                    {areaCount > 1 ? "[s]" : ""} to approve.
                  </Typography>
                </div>
              ) : (
                ""
              )}
            </Fragment>
          </ApproveMailingListPendingActions>
          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                margin: "8px",
                height: "48px",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div
              className={classNames(
                classes.portletFooter,
                classes.approvalFooter,
              )}
              style={{ width: "auto" }}
            >
              <ApproveMailingListPendingActions
                {...props}
                mode="footer"
                handleClose={handleClose}
              >
                <div className={classes.footerButtons}>
                  <div className={classes.footerButtonsLeftRight}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(event) => continueEditingModeFn()}
                    >
                      CONTINUE EDITING
                    </Button>
                  </div>
                  <div className={classes.footerButtonsCenter}>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.finishedButton}
                      onClick={(event) => {
                        setLoading(true);
                        approveMailingListFn();
                      }}
                    >
                      OK, I’M FINISHED
                    </Button>
                  </div>
                  <div className={classes.footerButtonsLeftRight}></div>
                </div>
              </ApproveMailingListPendingActions>
            </div>
          )}
        </MailProDialogBody>
      </MailProDialog>
    </div>
  );
};

ApprovalMailingListDialog.propTypes = {
  approveMailingListFn: PropTypes.func.isRequired,
  continueEditingModeFn: PropTypes.func.isRequired,
  mlsAreas: PropTypes.array.isRequired,
  areaName: PropTypes.string.isRequired,
  hoFilter: PropTypes.string.isRequired,
  currentArea: PropTypes.object,
};

// defaultProps removed in favor of default parameters

export default compose(withStyles(styles))(ApprovalMailingListDialog);
